import { FundingCategoryAssemblyBase } from './base/funding-category-assembly-base';

export class FundingCategoryAssembly extends FundingCategoryAssemblyBase { }